// components/scripts/RingCentralChat.tsx
"use client";

import Script from "next/script";

export default function RingCentralChat() {
  return (
    <Script
      id="ringcentral-chat"
      strategy="afterInteractive"
      src="https://aklscjjyui.chat.digital.ringcentral.com/chat/6aecff6ccaf5b73f86d0c6cc/loader.js"
    />
  );
}
